(function () {
  var config = window.__tepoBannerTracking;
  if (!config || !config.enabled || !config.measurementId) return;

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target.closest('[data-ga-banner]');
      if (!el) return;

      if (el.closest('[aria-hidden="true"]')) return;

      var params = {
        send_to: config.measurementId,
        banner_section: el.dataset.gaBanner || '',
        banner_name: el.dataset.gaBannerName || '',
        banner_position: el.dataset.gaBannerPosition || '',
        link_url: el.dataset.gaBannerDestination || el.getAttribute('href') || '',
      };

      if (typeof gtag === 'function') {
        gtag('event', 'banner_click', params);
      }
    },
    true
  );
})();
